import { useState, useEffect } from "react";
import "./App.css";
import "./icon.css";
import { BsWind } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import axios from "axios";
import {CiLocationOff} from "react-icons/ci"
const App = () => {

  const [wind, setWind] = useState({
    speed : 0
  });

    const [city, setData] = useState({

  });

  const [con, setCountry] = useState({
    country: "IN"
  });

  const [search, setSearch] = useState("Delhi");


  useEffect(() => {
    const fetchApi = async () => {
      const unit = "metric";
      const apiKey = "4d8fb5b93d4af21d66a2948710284366";
      const url = `https://api.openweathermap.org/data/2.5/weather?q=${search}&appid=${apiKey}&units=${unit}`;

      const response = await fetch(url);
      const resJson = await response.json();
     
      setData(resJson.main);
      setWind(resJson.wind);
      setCountry(resJson.sys);
    };

    fetchApi();
  }, [search]);
  
  return (
<>
<div className="box">
        <div className="inputData">
          <input
            className="inputField"
            type="search"
            placeholder="Search A Place"
            onChange={(event) => {
              setSearch(event.target.value);
            }}
          />
        </div>

        {!city ? (
          <div className="errorMsg">
            <p >Could Not Find</p> 
           <div>  <CiLocationOff className="con" /><div></div>  </div>
            <br /> <p> Try Different One</p>
           
          </div>
        ) : (
          <div>



            <div className="info">
              <h2 className="location">
              <div>
            < CiLocationOn />
            <h5 className="cont">{con.country}</h5>
            </div>
                {search}
              </h2>
              <h1 className="temp">
              {Math.round(city.temp)}°C
              
              </h1>
              
              <h3 className="tempmin_max">
              <img className="hum" src="/hum.png" />
              {Math.round(city.humidity)}% <br/> <BsWind/> {Math.round(wind.speed)} Km/hr
              </h3>
            </div>

            <div className="wave -one"></div>
            <div className="wave -two"></div>
            <div className="wave -three"></div>
          </div>
        )}
      </div>
      <footer>
        <h3> 
          Designed & Maintained with ❤ by Sunny &copy; 2023 All rights reserved
        </h3>
      </footer>
</>
  );
};

export default App;
